import React from 'react'
import { Container, Navbar } from 'react-bootstrap'

function Header() {
  return (

        <div className="sticky top-0 z-10 border-b border-gray-200 " style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
        <Navbar className=''>
         <Container className='flex flex-row justify-content-center h-36 p-12' >
           <Navbar.Brand href="#home">
             <img src="/Assets/ezgif.com-webp-to-png.png" alt="broken-image" className='h-28 m-3  p-1 flex flex-row justify-content-center'/>
           </Navbar.Brand>
           <Navbar.Brand >
             <img src="https://anxiety-meter-quiz.web.app/positive-text.png" alt="broken-image1" className='h-20 m-2 p-1 flex flex-row justify-content-center'/>
           </Navbar.Brand>
         </Container>
       </Navbar>
    </div>
  )
}

export default Header